
import { useEffect } from 'react';

// Auto-reloads the page when a new Service Worker takes control. The SW itself uses
// skipWaiting + clientsClaim (see app/sw.ts), so a freshly deployed version activates
// immediately; this listener completes the cycle by reloading any open tab to load the
// matching JS bundles.
//
// Caveat: in-progress form input is lost on reload. The user accepted this trade-off
// for "always-fresh, never-prompt" updates. If that becomes a pain point, swap to a
// toast-with-button flow.
export function SwUpdater() {
    useEffect(() => {
        if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

        // Skip the first activation (no prior controller = first install, not an update).
        // Without this guard the page reloads itself the first time the SW installs.
        const hadControllerOnMount = !!navigator.serviceWorker.controller;
        if (!hadControllerOnMount) return;

        let reloading = false;
        const onControllerChange = () => {
            if (reloading) return;
            reloading = true;
            window.location.reload();
        };

        navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
        return () => {
            navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
        };
    }, []);

    return null;
}
